/* globals drupalSettings */

import React, { useGlobal } from 'reactn';
import { debounce } from 'lodash';

import UserInfo from '../user-info/UserInfo';
import Numpad from '../numpad/numpad';
import RoomNumberInput from './RoomNumberInput';
import { BookingSummary, ErrorSummary } from './Summary';

const ConfirmForm = () => {
    const [booking, setBooking] = useGlobal('booking');
    const [roomNumber, setRoomNumber] = useGlobal('roomNumber');
    const [isConfirming, setConfirming] = useGlobal('confirming');
    const [error, setError] = useGlobal('error');
    const [, setLoading] = useGlobal('loading');

    const fetchResults = debounce(async value => {
        setLoading(true);

        const response = await fetch(`/api/package/search?roomNumber=${value}`);
        const data = await response.json();

        setConfirming(true);
        setError(data.error);
        setBooking(data.booking);
        setLoading(false);
    }, 300);

    const onRoomNumberChange = value => {
        setRoomNumber(value);

        if (value.length === 4) {
            fetchResults(value.join(''));
        }
    };

    return (
        <>
            <div className="l-main-55__left">
                <header className="section header">
                    <a href={drupalSettings.urls.front} className="header__logo">
                        <img src={drupalSettings.logo?.url} alt={drupalSettings.logo?.alt} />
                    </a>
                </header>
                <div className="l-main-55__content">
                    <RoomNumberInput fetchResults={fetchResults} />
                </div>
            </div>

            <div className="l-main-55__right">
                <UserInfo
                    fullName={drupalSettings.user.fullName}
                    editUrl={drupalSettings.urls.userEdit}
                    logoutUrl={drupalSettings.urls.userLogout}
                />
                {!isConfirming && <Numpad value={roomNumber} setValue={onRoomNumberChange} />}
                {error && <ErrorSummary error={error} />}
                {booking && <BookingSummary booking={booking} />}
            </div>
        </>
    );
};

export default ConfirmForm;
